module.exports = __webpack_public_path__ + "img/slide5.45810b2d.gif";